import classNames from 'classnames'
import { ElementType } from 'react'

import { Transition } from './Transition'
import { FadeProps } from './types'

const defaultElement = 'div'

/**
 * The Fade transition component is a helper to show and hide components using an opacity fade.
 */
export const Fade = <E extends ElementType = typeof defaultElement>({
  as,
  enter,
  exit,
  show,
  ...props
}: FadeProps<E>): JSX.Element => {
  const element: React.ElementType = as || defaultElement
  return (
    <Transition
      as={element}
      enter={classNames('animate-fade-in', enter)}
      exit={classNames('animate-fade-out', exit)}
      show={show}
      {...props}
    />
  )
}
